import { DeclarationItemState, FullDeclaration, MemberReturn, StepProps } from '../../../types'
import { Icons } from '../../../components/Icon'
import {
  formatDeclarationItem,
  fullDeclarationToDeclaration,
} from '../../../helpers/DeclarationHelpers'
import { actions } from '../../../redux'

type DeclarationListStepProps = StepProps & MemberReturn

export const useDeclarationListStep = (props: DeclarationListStepProps) => {
  const { t, dispatch, declarations, declarationListStepPartText, declarationListLabel } = props

  return {
    stepPart: {
      text: declarationListStepPartText,
    },
    label: declarationListLabel,
    text: t('declaration.form.declarationList.text'),
    form: {
      initialValues: {},
      validationSchema: undefined,
      onSubmit: () => {
        dispatch(actions.declaration.setNextStep())
      },
      validateOnMount: true,
    },
    fields: [
      {
        field: {
          numberHeaderLabel: t(
            'declaration.form.addDeclaration.declarationTable.numberHeaderLabel'
          ),
          descriptionHeaderLabel: t(
            'declaration.form.addDeclaration.declarationTable.descriptionHeaderLabel'
          ),
          actionHeaderLabel: t(
            'declaration.form.addDeclaration.declarationTable.actionHeaderLabel'
          ),
          stateHeaderLabel: t('declaration.form.addDeclaration.declarationTable.stateHeaderLabel'),
          refusedStateLabel: t(
            'declaration.form.addDeclaration.declarationTable.refusedStateLabel'
          ),
          validatedStateLabel: t(
            'declaration.form.addDeclaration.declarationTable.validatedStateLabel'
          ),
          pendingStateLabel: t(
            'declaration.form.addDeclaration.declarationTable.pendingStateLabel'
          ),
          editingStateLabel: t(
            'declaration.form.addDeclaration.declarationTable.editingStateLabel'
          ),
          declarations: (declarations as FullDeclaration[])?.map((item, index) => ({
            id: index + 1,
            description: formatDeclarationItem(t, fullDeclarationToDeclaration(item)),
            state: DeclarationItemState.Validated,
          })),
        },
        type: 'declarationTable',
      },
    ],
    button: {
      text: t('declaration.form.declarationList.submit.label'),
      iconProps: {
        icon: Icons.arrowRight,
      },
      iconPosition: 'right',
      disabled: false,
    },
  }
}
